export enum ThinBorderStyle {
  THIN_BORDER_LEFT,
  THIN_BORDER_RIGHT,
}
